import React from 'react';
import { useState, useEffect, useContext } from 'react';
import { AppContext } from "../../utils/ContextProvider";
import Loader from "../Loader";
import { Link, useNavigate } from 'react-router-dom';
import './style.css'
import API from '../../utils/API';
import Swal from 'sweetalert2';

const Clients = () => {
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const context = useContext(AppContext)
    const navigate = useNavigate();
    const [filteredData, setFilteredData] = useState([])
    const [filters, setFilters] = useState({ active: [1] })

    useEffect(() => {
        if (!context.getUserInfo) return
        let access = ["access_clients_list", "create_clients", "update_clients"]
        if (!access.some(item => context.getUserInfo[item] === true)) {
            navigate('/settings/users')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [context.getUserInfo])


    useEffect(() => {
        setLoading(true)
        if (!context.getUserInfo) return
        const cancelToken = API.cancelToken();
        
        API.getClients(cancelToken).then(res => {
            setLoading(false)
            setData(res.data)
            return
        }).catch(err => {
            setLoading(false)
            console.log(err)
            if (err.message === 'cancelling') return
            Swal.fire({
                title: 'Error.',
                text: 'Please try again later.',
                icon: 'warning',
                confirmButtonText: 'Ok',
                confirmButtonColor: '#007b4e'
            });

        })

        return () => {
            API.cancel(cancelToken);
        }
    }, [context.getUserInfo])

    useEffect(() => {
        if (data.length === 0) return
        let temp = JSON.parse(JSON.stringify(data))
        for (let field in filters) {
            if (filters[field] === "null") continue
            if (field === 'active') {
                if (filters[field] !== null) temp = temp.filter(line => filters[field].includes(parseInt(line[field])))
            } else {
                if (filters[field] !== '') temp = temp.filter(line => line[field].toLowerCase().includes(filters[field].toLowerCase()))
            }
        }
        setFilteredData(temp)
    }, [data, filters])

    const sortOptions = (a, b) => {
        var titleA = a.client_name
        var titleB = b.client_name
        if (titleA > titleB) {
            return 1;
        }
        if (titleA < titleB) {
            return -1;
        }
        return 0;
    }

    // const removeFilter = (name) => {
    //     setFilters(({ [name]: _, ...rest }) => rest)
    // }

    const handleFilter = ({ key, value }) => {
        let tempFilters = { ...filters }
        tempFilters[key] = value
        setFilters(tempFilters)
    }


    return (
        <div className='tablet:p-8 mobile:p-3 min-h-[90vh]'>
            <div className='card tablet:p-8 mobile:p-3 min-h-[80vh]'>
                <div className="flex flex-nowrap justify-between tablet:m-8 mobile:m-3">
                    <div className="flex flex-nowrap justify-center items-center rounded-md border border-[#007b4e] mr-4 pl-2">
                        <p className='text-[14px] font-semibold'>Client Status:</p>
                        <select className='border-none text-[12px] font-semibold h-[33px]' defaultValue={filters.active} name="active" onChange={(event) => handleFilter({ key: "active", value: event.target.value })}>
                            <option value={[0,1]}>All</option>
                            <option value={[0]}>Inactive</option>
                            <option value={[1]}>Active</option>
                        </select>
                        {/* <div className='w-[5px]'></div>
                        <div className="flex flex-nowrap justify-center items-center h-full rounded-r-sm w-[30px] h-full bg-[#007b4e] cursor-pointer"
                            onClick={() => removeFilter("active")}>
                            {GlobalSVG.close('white')}
                        </div> */}
                    </div>
                    <div className="flex flex-nowrap justify-center items-center rounded-md border border-[#007b4e] mr-4 pl-2">
                        <p className='text-[14px] font-semibold mr-2'>Client Name:</p>
                        <input className="border-none" type="text" name="client_name" onChange={(event)=>handleFilter({key: "client_name", value: event.target.value})} />
                        {/* <div className='w-[5px]'></div>
                        <div className="flex flex-nowrap justify-center items-center h-full rounded-r-sm w-[30px] h-full bg-[#007b4e] cursor-pointer"
                            onClick={() => removeFilter("active")}>
                            {GlobalSVG.close('white')}
                        </div> */}
                    </div>
                </div>
                <div className='h-5/6 w-full border-light-green mt-8'>
                    <div className='h-[60vh] overflow-y-auto'>
                        {
                            loading === true ?
                                <Loader />
                                :
                                filteredData.sort((a, b) => sortOptions(a, b)).map((e, index) => (
                                    <Link key={index + "tableitem"} className='w-full p-4 input-border flex flex-wrap' to={`/client?client=${e.client_id}`}>
                                        <p>{e.client_name}</p>
                                    </Link>
                                ))
                        }
                    </div>
                </div>
                <Link to={`/client/create`} className='w-full border-light-green block mt-8 text-sm text-green4 font-medium'>
                    <span className='text-lg mr-2'>+</span>
                    Add new client
                </Link>
            </div>
        </div >
    );
};

export default Clients;